import { CloseButton, Divider, Flex, Text } from '@chakra-ui/react';
import { Button, Modal, Radio } from '@morressier/alembic';

export type DuplicateAccountField =
  | 'fullName'
  | 'email'
  | 'orcid'
  | 'affiliation'
  | 'emptyOrcid';

export interface DuplicateAccountOption {
  label: string;
  value: DuplicateAccountField;
}

interface FetchDuplicateAccountsModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  options: DuplicateAccountOption[];
  selectedField: DuplicateAccountField;
  onChange: (field: DuplicateAccountField) => void;
  onClose: () => void;
  onFetch: () => void;
}

const FetchDuplicateAccountsModal = ({
  isOpen,
  isLoading = false,
  options,
  selectedField,
  onChange,
  onClose,
  onFetch
}: FetchDuplicateAccountsModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="620px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        direction="column"
        maxHeight="80vh"
        overflowY="auto"
        backgroundColor="surfacePrimaryFill"
      >
        <Flex direction="column" pt={6} pb={6} gap={6}>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            px={{ base: 4, md: 8 }}
            gap={4}
          >
            <Text textStyle="headingGroup">Fetch Similar Accounts</Text>
            <CloseButton onClick={onClose} />
          </Flex>

          <Divider borderColor="#D9D9D9" width="100%" />

          <Flex direction="column" px={{ base: 4, md: 8 }} gap={4}>
            <Text textStyle="textBody" color="#344054">
              Select the field you want to use to find similar accounts.
            </Text>

            <Flex direction="column" gap={4}>
              {options.map(option => (
                <Flex key={option.value} alignItems="flex-start">
                  <Radio
                    id={`duplicate-account-field-${option.value}`}
                    name="duplicate-account-field"
                    value={option.value}
                    checked={selectedField === option.value}
                    ariaLabel={option.label}
                    onChange={() => onChange(option.value)}
                  >
                    <Text textStyle="headingItem">{option.label}</Text>
                  </Radio>
                </Flex>
              ))}
            </Flex>
          </Flex>
        </Flex>

        <Flex
          justifyContent="flex-end"
          direction={{ base: 'column-reverse', md: 'row' }}
          gap={3}
          paddingX={{ base: 4, md: 8 }}
          paddingY={5}
          borderTop="1px solid"
          borderColor="#D9D9D9"
        >
          <Button
            variant="secondary"
            onClick={onClose}
            isDisabled={isLoading}
            width={{ base: '100%', md: 'auto' }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onFetch}
            isLoading={isLoading}
            isDisabled={isLoading}
            width={{ base: '100%', md: 'auto' }}
          >
            Fetch
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default FetchDuplicateAccountsModal;
